if (!customElements.get("product-sticky-bar")) {
    class ProductStickyBar extends HTMLElement {
        connectedCallback() {
            this.button = this.querySelector("[data-sticky-submit]");
            this.labelFull = this.button ? this.button.querySelector("[data-sticky-label-full]") : null;
            this.labelShort = this.button ? this.button.querySelector("[data-sticky-label-short]") : null;
            this.label = this.labelFull;
            this.defaultFull = this.labelFull ? this.labelFull.textContent.trim() : "";
            this.defaultShort = this.labelShort ? this.labelShort.textContent.trim() : "";

            // The form shows either a configurator opener or a plain add to cart button.
            this.source =
                document.querySelector(".product__configurator-open button") ||
                document.querySelector('.product__submit button[type="submit"]');

            if (!this.button || !this.source) return;

            this.syncLabel();
            this.syncState();

            this.button.addEventListener("click", () => this.source.click());

            this.observer = new MutationObserver(() => {
                this.syncLabel();
                this.syncState();
            });
            this.observer.observe(this.source, {
                attributes: true,
                attributeFilter: ["disabled", "class"],
                childList: true,
                characterData: true,
                subtree: true
            });

            this.reveal();
        }

        disconnectedCallback() {
            if (this.observer) this.observer.disconnect();
            if (this.sourceObserver) this.sourceObserver.disconnect();
        }

        syncLabel() {
            if (!this.labelFull) return;

            /* Przycisk zrodlowy moze niesc DRUGA linie - termin dostawy w przycisku
               konfiguratora (Figma 2039:5274). W pasku miesci sie jedna linia, wiec
               kopiujemy wylacznie etykiete akcji; bez tego pasek pokazywal
               "Skonfiguruj i kup (W Twoim domu w 5-6 tygodni)" zawinięte na dwie
               linie (zlapane 26 sie 2026). */
            const labelSource =
                this.source.querySelector(".product__configurator-open-label") || this.source;
            const text = labelSource.textContent.replace(/\s+/g, " ").trim();
            if (!text) return;

            this.labelFull.textContent = text;

            // Krotka etykieta zostaje tylko dla zwyklego dodania do koszyka.
            // Inna akcja (konfigurator) musi byc widoczna takze na mobile.
            if (this.labelShort) {
                this.labelShort.textContent =
                    text === this.defaultFull ? this.defaultShort : text;
            }
        }

        syncState() {
            this.button.disabled = this.source.disabled === true;
            this.button.classList.toggle("loading", this.source.classList.contains("loading"));
        }

        /* Pasek pokazuje sie DOPIERO, gdy prawdziwy przycisk zakupu w kolumnie
           wyjedzie z ekranu w gore (decyzja usera 26 sie 2026 - dopoki przycisk
           jest widoczny, pasek jest dublem i zaslania tresc). Wraca do ukrycia,
           gdy uzytkownik przewinie z powrotem do przycisku.

           Warunek "w gore" jest istotny: bez niego pasek pokazywalby sie takze
           przed dojechaniem do przycisku, czyli na samej gorze strony na waskich
           ekranach, gdzie kolumna zakupowa jest pod galeria. */
        reveal() {
            /* `hidden` schodzi od razu: dalej o widocznosci decyduje klasa
               `is-revealed`, bo `display: none` nie da sie animowac, a pasek
               ma WJEZDZAC z dolu. Do pierwszego pomiaru stoi poza ekranem
               (transform + visibility w arkuszu), wiec nic nie mruga. */
            this.hidden = false;

            if (!("IntersectionObserver" in window)) {
                this.classList.add("is-revealed");
                return;
            }

            /* Zapas 240 px: pasek wjezdza nie w chwili, gdy przycisk styka sie
               z krawedzia okna, ale gdy jest juz wyrazne kawalek wyzej. Gorny
               `rootMargin` rozszerza obszar obserwacji w gore, wiec przycisk
               liczy sie jako "jeszcze widoczny" przez te 240 px. */
            this.sourceObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        const przewinietoPonizej = entry.boundingClientRect.top < 0;
                        const pokaz = !entry.isIntersecting && przewinietoPonizej;
                        this.classList.toggle("is-revealed", pokaz);
                    });
                },
                { rootMargin: "240px 0px 0px 0px", threshold: 0 }
            );
            this.sourceObserver.observe(this.source);
        }
    }

    customElements.define("product-sticky-bar", ProductStickyBar);
}
